export default "__VITE_ASSET__46ffd7e7__"